import { Component } from '@angular/core';

@Component({
  selector: 'app-ngb-collapse-demo',
  templateUrl: './collapse-demo.component.html',
})
export class NgbCollapseDemoComponent {
  public isCollapsed = false;
}
